const $ = require('jquery');

var flipper_array = {};

function setFlipperSwitch(flipname) {
	flipper_array[flipname] = true;
}

function isFlipperSwitch(flipname) {
	if(flipper_array[flipname]){
		return true;
	} else {
		return false;
	}

}

///// standardize to UTC - as it is only for display and input/output should be in same TZ
/// important if stored timestamp is returned to date on server side in php
function datetimeToInt(datetime) {

	// dates come in as dd/mm/yyyy but should be yyyy-mm-dd
	var datearray = datetime.toString().split("/");
	var newdate = datearray[2] + '/' + datearray[1] + '/' + datearray[0];
	var dateTS = Date.UTC(datearray[2], datearray[1]-1, datearray[0],0,0,0) / 1000;

	return dateTS;

}

///// standardize to UTC - as it is only for display and input/output should be in same TZ
function intToDatetime(TSint) {

	var date = new Date(TSint*1000);
	var day = date.getUTCDate();
	var month = date.getUTCMonth()+1;
	var year = date.getUTCFullYear();
	// formatted as dd/mm/yyyy
	var datetime = padDigits(day,2) + '/' + padDigits(month,2) + '/' + year;

	return datetime;

}

function formatTime(TSint) {
    var dt = new Date(TSint * 1000);

    var hours = dt.getHours();
    var minutes = dt.getMinutes();
    var seconds = dt.getSeconds();
    return padDigits(hours,2) + ":" + padDigits(minutes,2) + ":" + padDigits(seconds,2);
} 


function getTimestampFromFrenchDateString(datestring){
        myDate=datestring.toString().split("/");
        ts = new Date(parseInt(myDate[2], 10), parseInt(myDate[1], 10) - 1 , parseInt(myDate[0]), 10).getTime();
        return ts;
}
	
	///// NO sprintf in javascript ??????!!!!!
function padDigits(number, digits) {
    return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number;
}

function parseQueryString( queryString ) {
    var params = {}, queries, temp, i, l;
 
    // Split into key/value pairs
    queries = queryString.toString().split(new RegExp("[&?]+", "g"));
 
    // Convert the array of strings into an object
    for ( i = 0, l = queries.length; i < l; i++ ) {
        temp = queries[i].split('=');
        params[temp[0]] = temp[1];
    }
 
    return params;
};

function numericFieldApprox(value,searchString, delta){
    if(
        (
            parseFloat(value) - parseFloat(searchString) <= delta 
            && parseFloat(value) - parseFloat(searchString) >= -delta
        )
        || searchString == '' //reset
    ){
        return true;
    } else {
        return false;
    }
}

function formatDuree(raw_duree){
    if(!raw_duree){return '0';}
    var raw_duree = parseFloat(raw_duree),
        formatted_duree = '',
        heures = parseInt(raw_duree),
        minutes = raw_duree-heures;
    if(heures != 0){formatted_duree += heures+'h';}
    if(minutes != 0){formatted_duree += minutes*60+'min';}
    if(formatted_duree == ''){formatted_duree = '0';}
    return formatted_duree;
}


function bindWithDelay(elem, callback, delay) {
// exec 'callback' on 'elem', after 'delay' ms if keyup not triggered again
// use : input dynamic update
    var timer = null;
    $(elem).keyup(function() {
        if (timer) {
            window.clearTimeout(timer);
        }
        var elem = this;
        timer = window.setTimeout( function() {
            timer = null;
            callback(elem);
        }, delay );
    });
    return elem;
};

function openInNewTab(url) {
    $("<a>").attr("href", url).attr("target", "_blank")[0].click();
};

// this function filters a wrapper set based on recursiveDepth
function sameDepthFilter(wrapper_set, context){
    return wrapper_set.filter(function(){
        return context.data('recursiveDepth') == $(this).data('recursiveDepth');
    });
}

var affichPrecision = 100;
function affichNumber(value){
    return Math.round(value * affichPrecision) / affichPrecision;
}

function checkUserExists(options){
    $('[name=nom], [name=prenom]').blur(function(){
        if($('#nom').val() != '' && $('#prenom').val() != ''){
            $.ajax({
                url : 'sophiacloud/testUserExists.php?skins='+options.skins+'&nom='+$('#nom').val()+'&prenom='+$('#prenom').val(),
                dataType : 'json',
                success : function(data){
                    if(data.match == 'true'){
                        $('#user_exists_modal').modal();
                        $('#user_exists_modal .nom').text(data.nom);
                        $('#user_exists_modal .prenom').text(data.prenom);
                        // $('#user_exists_modal .link').attr('href', 'index.php?page=UserProfile&user_id='+data.user_id);
                    }
                }
            });
        }
    });
}

module.exports = {	
    openInNewTab : openInNewTab,
    numericFieldApprox : numericFieldApprox,
    parseQueryString : parseQueryString,
    intToDatetime : intToDatetime,
    datetimeToInt : datetimeToInt,
    formatTime : formatTime,
    formatDuree : formatDuree,
    checkUserExists : checkUserExists,
    // TODO
    bindWithDelay : bindWithDelay,
    setFlipperSwitch : setFlipperSwitch,
    isFlipperSwitch : isFlipperSwitch,
    affichNumber : affichNumber,
    sameDepthFilter : sameDepthFilter
};
